import { candidatureApiClient } from "../../services/apiClient";

// Interface pour une candidature
export interface Candidature {
    id: string;
    consultantId: string;
    missionId: string;
    nom: string;               // ← Ajouté
    status: string;
    cvPath?: string;
    publicationDate: number[]; // Date de la candidature
}

// Payload pour la création d’une candidature
export interface PostCandidaturePayload {
    consultantId: string;
    missionId: string;
    nom: string;               // ← Ajouté
    status: string;
    cvBase64: string;
}

/**
 * Récupère la liste des candidatures d’un utilisateur.
 */
export async function getMesCandidaturesByUserId(userId: string): Promise<Candidature[]> {
    try {
        const response = await candidatureApiClient.get<Candidature[]>(
            `/candidatures/consultant/${userId}`
        );
        return response.data;
    } catch (error) {
        if ((error as any).status === 404) {
            console.warn("Aucune candidature trouvée pour cet utilisateur.", userId);
            return [];
        }
        throw new Error("Erreur lors de la récupération des candidatures : " + (error as Error).message);
    }
}

/**
 * Récupère la liste des candidatures d’une mission.
 */
export async function getCandidaturesByMissionId(missionId: string): Promise<Candidature[]> {
    try {
        const response = await candidatureApiClient.get<Candidature[]>(
            `/candidatures/mission/${missionId}`
        );
        return response.data;
    } catch (error) {
        throw new Error("Erreur lors de la récupération des candidatures : " + (error as Error).message);
    }
}

/**
 * Envoie une nouvelle candidature au backend.
 */
export function postCandidature(data: PostCandidaturePayload) {
    return candidatureApiClient.post('/candidatures', data);
}

/**
 * Alias pour récupérer les candidatures du consultant connecté.
 */
export async function getMesCandidatures(userId: string): Promise<Candidature[]> {
    return getMesCandidaturesByUserId(userId);
}